<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="payHistory">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">


                <div class="bc d-flex align-items-center pl-3">
                    <!-- <img alt="Logo" src="../../assets/img/purse.png" class="mh-40px pb-2"> -->
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Payment History
                            </b></h3>
                        <!-- <p class="text-muted card-sub-title mb-0">
                                        Fee Process
                                      </p> -->
                    </div>
                </div>


                <div class="row clearfix">
                    <div class="table-responsive mt-4 widthTb">
                        <table id="datatable" class="table table-bordered text-nowrap text-left">
                            <thead>
                                <tr>
                                    <th width="10%" class="f600">Fee Head</th>
                                    <!-- <th width="10%" class="f600">FeeAmt</th> -->
                                    <th width="20%" class="f600">FeePaid</th>
                                    <!-- <th width="20%" class="f600">Due Amount</th>
                                            <th width="20%" class="f600">Payment Mode</th> -->
                                    <th width="30%" class="f600">Date & Time</th>

                                </tr>
                            </thead>

                            <tbody id="table_data">
                                <!-- examSemList -->
                                <tr *ngFor="let item of payHistoryData; let i=index;">

                                    <td>{{item.Head}}</td>
                                    <!-- <td>{{item.FeeAmt}}</td> -->

                                    <td *ngIf="Currency == 'USD' ">
                                        <span class="currency-symbolTd">$ </span>  {{item.FeeAmt}}
                                    </td>
                                    <td *ngIf="Currency == 'INR' ">
                                        <span class="currency-symbolTd">&#8377;</span>  {{item.FeeAmt}}
                                    </td>
                                    <td>
                                        <!-- {{item.FeePaymentDate}} -->
                                        {{ convertUTCToIST(item.FeePaymentDate) }}
                                    </td>

                                </tr>
                            </tbody>
                        </table>

                        <div class="col-sm-12"  *ngIf="Currency == 'INR' ">
                            <span class="Text">Total Paid Amount :</span>
                            <span class="currency-symbol">&#8377;{{this.totalpaid}}</span>

                        </div>
                        <div class="col-sm-12"  *ngIf="Currency == 'USD' ">
                            <span class="Text">Total Paid Amount :</span>
                            <span class="currency-symbol">${{this.totalpaid}}</span>

                        </div>
                    </div>

                    <div class="col-sm-12">
                    
                        <button type="button" class="btn fr sz btn-primary btn-icon-text floatright mt-1 mr-3 fr" (click)="close()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/letter-x.gif" style="margin-right: 7px;">
                                Close
                            </span>
                        </button>
                    </div>


                </div>

            </div>
        </div>
    </form>
</div>